<div id="editenduser" class="subBlockContainer">
    <div class="subBlockContent">
      <child-header [title]="title" (closeEvent)="close()"></child-header>
        <div class="inner-subBlock-wrapper">
            <!-- <div class="page-title-wrapper page-title-wrapper-margin">
                <div class="title blade-title-font">
                    {{title}}
                </div>
                <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
            </div> -->
            <div class="container">
                <div class="row" [formGroup]="userFormGroup">

                    <div class="userinfo col-md-6" style="display: none;">
                        <div class="usage-alert">Usage Alert Settings</div>
                        <p>To receive data usage notifications via email when the tenant exceeds an usage limit please set a dollar value below.</p>
                        <mat-form-field [floatLabel]="'always'">
                            <input matInput class="editTenantMinThresholdValidate" formControlName="out_min_threshold" placeholder="Warning Alert Limit">
                            <span matPrefix>$&nbsp;</span>
                            <mat-icon matSuffix matTooltipClass="tooltip-red" matTooltip="A warning email will be sent when usage exceeds the entered dollar value">info</mat-icon>
                        </mat-form-field>
                        <mat-form-field [floatLabel]="'always'">
                            <input matInput class="editTenantMaxThresholdValidate" formControlName="out_max_threshold" placeholder="Critical Alert Limit">
                            <span matPrefix>$&nbsp;</span>
                            <mat-icon matSuffix matTooltipClass="tooltip-red" matTooltip="A critical alert email will be sent when usage exceeds the entered dollar value">info
                            </mat-icon>
                        </mat-form-field>
                        <mat-form-field [floatLabel]="'always'">
                            <input matInput class="editTenantThresholdEmailValidate" formControlName="out_threshold_email" placeholder="Notification Email">
                        </mat-form-field>
                    </div>

                    <div class="userinfo">
                        <div class="payment-title">Payment Method</div>
                        <div id="list-payment">
                            <div class="noData-wrapper" *ngIf="!paymentList?.length">
                                <div>
                                    <img src="../images/new_ui/no-wallet.png">
                                </div>
                                <div class="noData-label">Your digital wallet is empty.</div>
                                <div class="button-center">
                                    <button
                                      id="addPaymentBtn"
                                      class="button button-red button-large"
                                      [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                                      [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                                      matTooltip="Requires Purchasing Permissions"
                                      (click)="navigateToDigitalWallet()"
                                    >Create new</button>
                                </div>
                            </div>



                            <ng-container *ngIf="paymentList?.length">
                                <div class="row margin-top-30">
                                    <div class="col-sm">
                                        <label class="po-label">Select a payment from your wallet</label><br /><br>
                                        <button class="button button-red button-mid reset-payment" [disabled]="!editable" (click)="resetPayment()">Reset Payment
                      Option</button>
                                        <mat-form-field>
                                            <mat-select [(value)]="selectedPayment" [disabled]="!editable" (selectionChange)="selectPaymentMethod();">
                                                <mat-option value="{{payment.value}}" selected *ngFor="let payment of paymentList">{{payment.text}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <ng-container *ngIf="hasEmptyFilterResult">
                                    <div class="noData-wrapper">
                                        <div><img src="../images/new_ui/no-wallet.png"></div>
                                        <div class="noData-label">Your digital wallet is empty.</div>
                                        <div class="button-center">
                                            <button 
                                              class="button button-red button-large" 
                                              (click)="navigateToDigitalWallet()"
                                              [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                                              [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                                              matTooltip="Requires Purchasing Permissions"
                                            >Create now</button>
                                        </div>
                                    </div>
                                </ng-container>

                            </ng-container>

                        </div>
                    </div>
                </div>
                <!-- <div class="row">
        <div class="userinfo col-md-12" *ngIf="companyCode==='T01' || companyCode==='1'">
          <div class="payment-title">Payment Method</div>
          <div id="list-payment">
            <div class="noData-wrapper" *ngIf="!paymentList?.length">
              <div>
                <img src="../images/new_ui/no-wallet.png">
              </div>
              <div class="noData-label">Your digital wallet is empty.</div>
              <div class="button-center">
                <button id="addPaymentBtn" class="button button-red button-large"
                  (click)="navigateToDigitalWallet()">Create new</button>
              </div>
            </div>

            <ng-container *ngIf="paymentList?.length">
              <div class="row margin-top-30 dropdownBox">
                <div class="col-sm">
                  <label class="po-label">Select a payment from your wallet</label><br />
                  <button class="button button-red button-mid reset-payment" (click)="resetPayment()">Reset Payment
                    Option</button>
                  <mat-form-field>
                    <mat-select [(value)]="selectedPayment" (change)="selectPaymentMethod();">
                      <mat-option value="{{payment.value}}" *ngFor="let payment of paymentList">{{payment.text}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <ng-container *ngIf="hasEmptyFilterResult">
                <div class="noData-wrapper">
                  <div><img src="../images/new_ui/no-wallet.png"></div>
                  <div class="noData-label">Your digital wallet is empty.</div>
                  <div class="button-center">
                      <button class="button button-red button-large" (click)="navigateToDigitalWallet()">Create
                          now</button>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div> -->
                <div class="button-center">
                    <button
                      class="button button-red button-large"
                      [disabled]="!editable || (!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess)"
                      [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"	
                      matTooltip="Requires Purchasing Permissions"
                    >Save</button>
                </div>
                <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false" backDropWidth="984" (currentLoadingStatus)="onLoading($event)"></loading-screen>
            </div>
        </div>
    </div>
    <router-outlet></router-outlet>
</div>